export default function CryptoInActive({ width = 14, height = 24, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 24"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M6.99902 22.0684L2.3291 15.3809L6.65723 17.9883L6.99902 18.1943L7.3418 17.9883L11.6689 15.3809L6.99902 22.0684Z"
                fill="#959595"
                stroke="#959595"
                strokeWidth="1.3265"
            />
            <path
                d="M0.90625 11.5503L7.00098 1.29834L13.0957 11.5503L7.00098 15.2896L0.90625 11.5503Z"
                stroke="#959595"
                strokeWidth="1.3265"
            />
        </svg>
    );
}
